import http from '@/http'

const API_PATH = 'organizations/:organizationId/admin/coupon/'

const configureApiPath = ({ organizationId }) => {
  return API_PATH.replace(':organizationId', organizationId)
}

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  async show({ rootGetters }, couponCode) {
    const apiPath = configureApiPath({ organizationId: rootGetters['auth/currentOrganization'].id })
    return http.get(apiPath + '?code=' + couponCode)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
